import { createTheme } from "@mui/material/styles";

// Commented by Akhil - Updated admin theme to light mode with organic colors matching homepage
const customTheme = createTheme({
  palette: {
    mode: "light", // Changed from dark to light theme
    primary: {
      main: '#6B8E23', // organic-green
    },
    secondary: {
      main: '#4A7C3F', // darker green for accents
    },
    white: {
      main: "#fff"
    },
    background: {
      default: '#ffffff',
      paper: '#ffffff'
    },
    text: {
      primary: '#1A1A1A', // organic-charcoal
      secondary: '#4A4A4A',
    },
  },


});

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#9155FD',
    },
    secondary: {
      main: '#f48fb1',
    },
  },
});

const customerTheme = createTheme({
  palette: {
    mode: "light", // Set the custom color mode name here
    primary: {
      main: '#9155FD',
    },
    secondary: {
      main: '#f48fb1',
    },
    white: {
      main: "#fff"
    },
    orange: {
      main: "#ffdb0f"
    },

    background: {
      default: '',
      // paper: '#121019',
      paper: "white"
    },
  },


});

export { customTheme, darkTheme, customerTheme };
